import apiClient from 'services/api';

export const requestReviewEditOtp = (contact: string) =>
  apiClient.post<{ ok: boolean }>('/public/reviews/edit/request-otp', {
    contact,
  });

export const verifyReviewEditOtp = (contact: string, code: string) =>
  apiClient.post<Kudable.EditableReviewsResponse>(
    '/public/reviews/edit/verify-otp',
    { contact, code },
  );

export const updateReviewViaToken = (
  reviewId: string,
  token: string,
  body: Kudable.UpdateReviewPayload,
) =>
  apiClient.put<{ review: Kudable.EditableReview }>(
    `/public/reviews/edit/${reviewId}`,
    { ...body, token },
  );
